// Pure helpers for the "Where this form appears" list.

// A page not seen for this long may no longer have the form on it.
export const STALE_DAYS = 30;

// isTestPage: an address on this computer or a local network, where the form
// is being tried out rather than shown to visitors.
export function isTestPage(pageUrl) {
  try {
    const host = new URL(pageUrl).hostname;
    return host === "localhost" || host === "127.0.0.1" || host === "[::1]" || host.endsWith(".local") ||
      /^(10|192\.168)\./.test(host) || /^172\.(1[6-9]|2\d|3[01])\./.test(host);
  } catch (e) {
    return false;
  }
}

export function isStale(placement, now = Date.now()) {
  const seen = Date.parse(placement && placement.last_seen_date);
  return !Number.isNaN(seen) && now - seen > STALE_DAYS * 24 * 60 * 60 * 1000;
}

// shortPage is a page address without the scheme, for display.
export function shortPage(pageUrl) {
  return String(pageUrl || "").replace(/^https?:\/\//, "");
}
